export default "__VITE_PUBLIC_ASSET__a66ef722__"